import { api } from '../../server/api';
import { IPlayerHierarchy } from './types';

interface IPlayerHierarchyResponse {
  error: boolean;
  message: string;
  body: IPlayerHierarchy;
}

export async function getPlayerHierarchy(
  playerId: string
): Promise<IPlayerHierarchy> {
  const response = await api.get<IPlayerHierarchyResponse>(
    `/players/${playerId}/hierarchy`
  );
  return response.data.body;
}
